import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import styles from "../styles/components/header.module.scss";
import NotificationBell from "../components/NotificationBell";
import { logOut } from "../actions/user-actions";
// Adding grid library
import { Row, Col } from "react-flexbox-grid";
import AvatarLiveli from "./Avatar";
import { HiInformationCircle } from "react-icons/hi";
import ReactTooltip from "react-tooltip";
import { setStep, setShowTutorial } from '../actions/user-actions';
// Adding brand identity to header
const LOGO = require("./../assets/images/logo.png");

export class Header extends Component {
  constructor(props) {
    super(props);
    // Defining user data by getting from local storage
    this.user = JSON.parse(localStorage.getItem("user"));
    this.state = {
      sidebarActive: true
    };
  }

  toggleSidebar = () => {
    this.setState({ sidebarActive: !this.state.sidebarActive },
      () => this.props.toggleSidebar()
    );
  };

  signOut = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      this.props.logOut({ accessToken: accessToken });
      localStorage.clear();
    }
  };

  openTutorial = () => {
    const currentPath  = window.location.href;
    const basePage = this.props.isFirstTutorial ? '/calendar' : '/settings'
    this.props.setStep(0)
    this.props.setShowTutorial(true, true)

    if (currentPath.indexOf(basePage) > -1) {
      this.props.history.push("/empty");
      setTimeout(() => {
        this.props.setShowTutorial(true, true)
        this.props.history.push(basePage);
      }, 0.00000001)
    } else { 
      this.props.history.push(basePage);
    }
  }


  render() {
    // Getting user name
    const { name } = this.user;

    return (
      <header className={styles.__divStyle}>
        <Row middle="xs">
          <Col xs={6}>
            <figure className={styles.brand}>
              <img src={LOGO} loading="lazy" alt="Liveli brand identity" />
            </figure>
          </Col>
          <Col xs={6}>
            <Row end="xs">
              <div 
                data-tip={'Tutorial'} 
                className='__bell' 
                data-for='tutorial'
                style={{marginRight: '1.5rem', background: '#FFF', height: '34px', marginTop: '4px'}}
                onClick={()=> this.openTutorial()}>
                  <div>
                    <HiInformationCircle size='50' color={'#68D2DF'}/>
                  </div>
                <ReactTooltip type='info' place='bottom' id='tutorial'/>
              </div>
              <div data-tip={'Notifications'} data-for='notifications'>
                <NotificationBell displayModal={this.props.displayModal} />
                <ReactTooltip type='info' place='bottom' id='notifications'/>
              </div>
              <div className={styles.__profile_img}>
                <AvatarLiveli name={name} signOut={this.signOut}/>
              </div>
            </Row>
          </Col>
        </Row>
      </header>
    );
  }
}

const mapStateToProps = state => {
  return {
    logOutSuccess: state.userReducer.logOutSuccess,
    logOutError: state.userReducer.logOutError,
    isFirstTutorial: state.userReducer.isFirstTutorial
  }
};

const mapDispatchToProps = dispatch => {
  return {
    logOut: accessToken => dispatch(logOut(accessToken)),
    setStep: (step) => dispatch(setStep(step)),
    setShowTutorial: (show, isTutorial) => dispatch(setShowTutorial(show, isTutorial))
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
